module.exports = __webpack_public_path__ + "static/media/AvantBold.c57e1498.otf";